<div class="poster-image-wrapper position-relative">
    <app-sensitive-content-container
        *ngIf="isCautionFlagContainerDisplayed"
        [actionButtonName]="cautionFlagButtonName"
        [customAction]="true"
        (customActionTrigger)="expand()"
        class="content-flags-overlay"
    >
    </app-sensitive-content-container>
    <div
        class="image-container"
        [ngStyle]="{
            'background-image': 'url(\'' + genericInteractiveMedia?.posterImage?.itsURL + '\')',
        }"
        [title]="genericInteractiveMedia?.posterImage?.getAltText()"
    >
        <span class="expand" (click)="expand()" *ngIf="genericInteractiveMedia?.url">
            <div class="p-2 notification-bar text-center" *ngIf="addOnViewService.isAddonView">
                This resource will launch in a separate browser window. Please return to Google
                Classroom to complete your work.
            </div>
            <app-button class="view-button selenium-launch-button">
                Launch <app-icon type="Expand"></app-icon>
            </app-button>
        </span>
    </div>
</div>
